module.exports = __webpack_public_path__ + "static/assets/60c8d046c7b5d074b5dc5dd82b340b5d.png";